import styled, { css } from 'styled-components';

import { type LabelPosition } from '@pkg/components/Sections/Admin/components/Form/Input';
import { styledTypography } from '@pkg/primitives';

export const StyledForm = styled.form`
    ${styledTypography.allianceBase};
    width: 100%;
`;

export const Wrapper = styled.div<{ $width?: string }>`
    display: flex;
    flex-direction: column;
    margin: 10px 0;

    ${({ $width }) =>
        $width &&
        css`
            width: ${$width};
        `}
`;

export const StyledLabel = styled.label`
    font-weight: 600;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledDescription = styled.p<{ $isError?: boolean }>`
    ${styledTypography.allianceBase};
    font-size: 14px;
    margin: 5px 0;
    position: relative;

    ${({ $isError }) => {
        if ($isError) {
            return css`
                color: ${(props) => props.theme.shades.red['90']};
                margin: 0 0 5px 0;
            `;
        }
    }}
`;

const SHARED_INPUT_STYLES = css`
    box-sizing: border-box;
    background: ${(props) => props.theme.shades.white['10']};
    color: ${(props) => props.theme.shades.white['80']};
    height: 40px;
    border-radius: 8px;
    font-weight: 400;
    border: none;
    width: 100%;
    font-size: 15px;
    padding: 4px 8px;
    color-scheme: dark;

    &:invalid {
        border: 1px solid ${(props) => props.theme.shades.red['10']};
    }
`;

export const StyledInputInnerLabel = styled.label<{ $position?: LabelPosition }>`
    position: relative;
    &::after {
        content: '' attr(data-inner);
        position: absolute;
        bottom: 4px;
        transform: translate(0, -50%);
        ${({ $position }) => {
            if ($position === 'start') {
                return css`
                    left: 10px;
                `;
            }
            if ($position === 'end') {
                return css`
                    right: 10px;
                `;
            }
        }}
    }
`;

export const StyledInput = styled.input<{ $labelInside?: boolean; $labelPosition?: LabelPosition }>`
    ${SHARED_INPUT_STYLES};
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    &::placeholder {
        color: ${(props) => props.theme.shades.white['50']};
    }

    ${({ $labelInside }) => {
        if ($labelInside) {
            return css`
                position: relative;
            `;
        }
    }};

    ${({ $labelPosition }) => {
        if ($labelPosition === 'start') {
            return css`
                padding: 5px 10px 5px 25px;
            `;
        }
    }};
`;

export const StyledCheckbox = styled.input`
    &[type='checkbox'] {
        display: flex;
        margin-right: 5px;
    }
`;
export const StyledSelect = styled.select<{ $compact?: boolean }>`
    ${SHARED_INPUT_STYLES};
    border-right: 10px solid transparent;
    outline: none;
    margin-bottom: 8px;

    ${({ $compact }) =>
        $compact &&
        css`
            height: 30px;
            font-size: 14px;
        `};
`;

export const DescriptionField = styled.span`
    margin: 5px 0;
    position: relative;
    color: #ffffff;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.03em;
    line-height: 120%;
    opacity: 0.5;
    text-align: inherit;
`;

export const StyledInputLabel = styled.span`
    font-size: 16px;
    font-weight: 600;
`;
